import React, { useEffect } from "react";
import { useParams } from "react-router";
import { ReactComponent as SendIcon } from "./../../images/send-arrow.svg";
import CheckedIconImg from "./icons/checked-brown.svg";
import {
  Badge,
  BadgeText,
  Form,
  Header,
  Page,
  ReviewCard,
  ReviewsGrid,
  ReviewText,
  StarIcon,
  SubmitButton,
  Text,
  TextArea,
  Wrapper,
} from "./ReviewPage.styles";

const CONFIG = {
  hu: {
    title: "Vélemények és értékelések a platformról",
  },
};

const ReviewPage = ({ data }) => {
  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
  }, [lang]);

  return (
    <Page>
      <Wrapper hasReviews={!!data.items}>
        <Header>{data.title}</Header>
        <Text>{data.subtitle}</Text>
        <Form action="https://formsubmit.co/support@eou-edu.eu" method="POST">
          <TextArea
            name="content"
            id="content"
            placeholder={data.contentPlaceholder}
          ></TextArea>
          <input
            type="hidden"
            name="_next"
            value={`${window.location.origin}/${data.language}/thankyou`}
          ></input>
          <SubmitButton type="submit">
            {data.submitButton} <SendIcon />
          </SubmitButton>
        </Form>

        {data.items && (
          <ReviewsGrid>
            {data.items.map((item, index) => (
              <ReviewCard
                key={index}
                isLarge={item.isLarge}
                isTall={item.isTall}
              >
                {item.isRecommended && (
                  <Badge>
                    <StarIcon src={CheckedIconImg} alt="Checked" />
                    <BadgeText>{data.recommendedLabel}</BadgeText>
                  </Badge>
                )}
                <ReviewText isDark={item.isLarge}>{item.text}</ReviewText>
              </ReviewCard>
            ))}
          </ReviewsGrid>
        )}
      </Wrapper>
    </Page>
  );
};

export default ReviewPage;
